import { Route, Routes } from "react-router-dom";
import { C_PATH_ROUTER } from "../../shared/model/const/path.const";
import PropertyProjectUpdatePage from "@rf/property/module/pages/update/PropertyProjectUpdatePage";
import PropertyUpdatePage from "@rf/property/module/pages/update/PropertyUpdatePage";
import RealestateDetailPage from "../realestate/pages/realestate-detail/RealestateDetailPage";
import { lazy } from "react";
import PropertyCreationPage from "./pages/create/PropertyCreationPage";
import PropertyProjectCreationPage from "./pages/create/PropertyProjectCreationPage";
import PropertyListPage from "./pages/list/PropertyListPage";
import PropertyDetailPage from "./pages/detail/PropertyDetailPage";
import Page404 from "@rf-l3/pages/404";
import PropertyDraftListPage from "./pages/draft-list/PropertyDraftListPage";

const LazyRealEstateConflicts = lazy(
  () => import("../realestate/pages/conflicts/RealEstateConflicts")
);
function PropertyRouterModule() {
  return (
    <Routes>
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DRAFT_LIST}
        element={<PropertyDraftListPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DRAFT_UPDATE}
        element={<PropertyCreationPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DRAFT_PROJECT_UPDATE}
        element={<PropertyProjectCreationPage />}
      />

      {/* <Route
        path={C_PATH_ROUTER.PROPERTIES.DETAIL}
        element={<RealestateDetailPage />}
      /> */}
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DETAIL_SHORT}
        element={<RealestateDetailPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.CREATE}
        element={<PropertyCreationPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.UPDATE}
        element={<PropertyUpdatePage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.PROJECT_CREATE}
        element={<PropertyProjectCreationPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.PROJECT_UPDATE}
        element={<PropertyProjectUpdatePage />}
      />
      <Route
        path={C_PATH_ROUTER.REALESTATE.RESOLVE_CONFLICT}
        element={<LazyRealEstateConflicts />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DETAIL}
        element={<PropertyDetailPage />}
      />

      <Route path={C_PATH_ROUTER.PROPERTIES.LIST} element={<PropertyListPage />} />

      <Route
        path="*"
        element={
          <Page404
            path={C_PATH_ROUTER.PROPERTIES.LIST}
            title="URL no válida"
            buttonMessage="Volver a la lista de propiedades"
          />
        }
      />
    </Routes>
  );
}

export default PropertyRouterModule;
